<template>
    <div class="mapBox">
        <div class="tmap" id="container" ref="container">
            <!-- 左上角控件 -->
            <div class="leftMenu">
                <!-- <div class="iconfont icon-sousuo" title="搜索"></div> -->
                <div class="iconfont icon-shuaxin3" title="回到中心" @click="resetMap"></div>
                <div class="iconfont icon-shaixuanguolv" title="筛选" @click="filterDeviceBoxShow = !filterDeviceBoxShow">
                </div>
                <div class="iconfont icon-shezhi" title="设置" @click="settingBoxShow = !settingBoxShow"></div>
            </div>


            <div class="menuBox" v-if="settingBoxShow">
                <div :class="$store.state.maxMarkerType * 1 == 1 ? 'list check' : 'list'" @click="changeMarkerType(1)">
                    在线状态
                </div>
                <div :class="$store.state.maxMarkerType * 1 == -1 ? 'list check' : 'list'"
                    @click="changeMarkerType(-1)">
                    报警状态</div>
                <div class="list line">|</div>
                <div :class="mapContleStyle ? 'list check' : 'list'" @click="changeMapThemeColor(1)">白昼</div>
                <div :class="!mapContleStyle ? 'list check' : 'list'" @click="changeMapThemeColor(0)">黑夜</div>
                <div class="list line">|</div>
                <div class="list" @click="settingMap">保存预设</div>
            </div>


            <div class="topmenuBox" v-if="filterDeviceBoxShow">
                <div>设备类型: <select v-model="filterDeviceForm.deviceType">
                        <option>全部</option>
                        <option v-for="(item, index) in deviceTypeOption" :key="index">{{ item }}</option>
                    </select></div>
                <div class="list line">|</div>

                <div>在线状态:<select v-model="filterDeviceForm.onlineStatus">
                        <option>全部</option>
                        <option>正常</option>
                        <option>报警</option>
                    </select></div>
                <div class="list line">|</div>

                <div>报警状态:<select v-model="filterDeviceForm.alarmStatus">
                        <option>全部</option>
                        <option>正常</option>
                        <option>报警</option>
                    </select></div>
                <div class="list line">|</div>

                <div class="list" @click="filterDevice">筛选</div>
                <div class="list" @click="resetDevice">重置</div>

                <div class="list iconfont icon-xiangxia1" v-show="!filterDetailShow" @click="openFilterDetail"></div>
                <div class="list iconfont icon-xiangshang" v-show="filterDetailShow" @click="closeFilterDetail"></div>

                <div class="deviceSummary" v-if="filterDetailShow">
                    <div v-for="(item, index) in filterDeviceData" :key="index" class="list">
                        <div class="id">
                            {{ item.deviceName }}
                        </div>
                        <div class="name">
                            {{ item.anotherName ? item.anotherName : '未设置' }}
                        </div>
                        <div class="r iconfont icon-daohang" title="查看位置" @click="goDeviceMap(item)">
                        </div>
                        <div class="r iconfont icon-xiangqing" title="查看详情" @click="openDeviceDetail(item)">
                        </div>
                    </div>
                </div>
            </div>


        </div>



        <contentbox v-show="settingBox" @close="settingBoxClose">
            <template slot="content">
                <div class="settingBox">
                    <div class="list">
                        <div class="title">地图主题颜色</div>

                        <div class="confimBox">
                            <div class="btn" @click="changeMapThemeColor(1)">白昼</div>
                            <div class="btn" @click="changeMapThemeColor(0)">黑夜</div>
                        </div>
                    </div>

                    <div class="list">
                        <div class="title">地图标记点类型</div>
                        <!-- <div class="valueBox">
                        </div> -->
                        <div class="confimBox">
                            <div class="btn">在线状态</div>
                            <div class="btn">报警状态</div>
                        </div>
                    </div>
                </div>
            </template>
            <template slot="btnMenu">456</template>
        </contentbox>

        <devicedeatil class="deviceDeatilZindex" v-if="deviceDeatilShow" :deviceData="checkDeviceData"
            @close="deviceDeatilShow = false">
        </devicedeatil>
    </div>
</template>

<script>
import contentbox from '@/components/common/maxWeb/contentbox.vue';
import GCJ02_WGS84 from '@/utils/GCJ02_WGS84.js';
import devicedeatil from '@/components/common/maxWeb/devicedeatil.vue';
import { mapGetters } from 'vuex';
import liwan from '@/utils/echartsMap/county/440103-荔湾区.json'
export default {
    data() {
        return {
            countries: [],
            mapContle: null, //地图实例
            settingBox: false, // 设置弹窗
            // 设备详情弹窗是否显示
            deviceDeatilShow: false,
            // 聚合点实例
            clusterMarkers: '',
            checkDeviceData: null,
            mapContleStyle: this.$store.state.maxMapStyle,
            // 设备类型
            deviceTypeOption: [],
            // 筛选数据
            filterDeviceForm: {
                deviceType: '全部',
                alarmStatus: '全部',
                onlineStatus: '全部',
            },
            // 筛选完的设备
            filterDeviceData: [],
            // 筛选状态
            filterStatus: false,
            // 是否打开筛选设备详情
            filterDetailShow: false,

            // 筛选设备组件展示
            filterDeviceBoxShow: false,
            // 搜索设备组件展示
            searchDeviceBoxShow: false,
            // 地图设置组件展示
            settingBoxShow: false

        };
    },
    mounted() {
        this.mapInit();
        this.getDeviceType()
    },
    computed: {
        ...mapGetters(['getNewDeviceData'])
    },
    components: {
        contentbox,
        devicedeatil
    },
    methods: {
        // 保存当前设置
        settingMap() {
            this.$confirm('将当前地图设置保存,以后每次进入都会默认显示当前界面设置', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    // 获取当前地图中心点和缩放层级
                    const center = this.mapContle.getCenter();
                    const zoom = this.mapContle.getZoom();
                    console.log(center);
                    console.log(zoom);
                    let obj = {
                        Lng: center.lng,
                        Lat: center.lat,
                        zIndex: zoom
                    };
                    this.$store.commit('setMaxMapSetting', obj);
                    localStorage.setItem('maxMapSetting', JSON.stringify(obj));
                    this.$message.success('设置成功');
                })
                .catch(() => { });
        },
        // 改变地图标记点类型
        changeMarkerType(e) {
            this.$store.commit('setMaxMarkerType', e);
            localStorage.setItem('maxMarkerType', e);
            this.setMapMarker(this.$store.state.maxMarkerType * 1, this.$store.state.deviceNowData);
            if (e == 1) {
                this.$message.success('切换为在线状态');
            } else if (e == -1) {
                this.$message.success('切换为报警状态');
            }
        },
        // 改变地图主题颜色
        changeMapThemeColor(e) {
            // 传递是1代表要设置白色 否则设置黑色

            switch (e) {
                case 1:
                    this.$store.commit('setMaxMapStyle', 1);
                    localStorage.setItem('maxMapStyle', 1);
                    this.mapContleStyle = 1;
                    this.mapContle.removeStyle();
                    break;
                case 0:
                    this.$store.commit('setMaxMapStyle', 0);
                    localStorage.setItem('maxMapStyle', 0);
                    this.mapContleStyle = 0;
                    this.mapContle.removeStyle();
                    // 设置黑色
                    this.mapContle.setStyle('black');
                    break;
                default:
                    break;
            }
        },
        // 关闭设置地图弹窗
        settingBoxClose() {
            this.settingBox = false;
        },

        // 获取当前用户的设备类型
        getDeviceType() {
            let data = this.$store.state.deviceNowData
            let arr = data.map(item => {
                return item.deviceType
            })
            this.deviceTypeOption = [...new Set(arr)]
        },

        // 地图初始化
        mapInit(e) {

            var map = new T.Map('container');

            this.mapContle = map;

            this.mapContle.centerAndZoom(
                new T.LngLat(this.$store.state.maxMapSetting.Lng * 1, this.$store.state.maxMapSetting.Lat * 1),
                this.$store.state.maxMapSetting.zIndex * 1
            );
            if (JSON.parse(localStorage.getItem('companyInfo')).companyId == 2) {
                var countries = [];
                var countriesOverlay = new T.D3Overlay(this.init, this.redraw);
                var countriesOverlay1 = new T.D3Overlay(this.init1, this.redraw1);

                d3.json("", (data) => {
                    countries = liwan.features;
                    this.countries = countries
                    this.mapContle.addOverLay(countriesOverlay)
                    countriesOverlay.bringToBack();
                    this.mapContle.addOverLay(countriesOverlay1)
                    countriesOverlay.bringToBack();
                });

            }
            //添加缩放平移控件
            this.mapContle.addControl(new T.Control.Zoom());
            //添加比例尺控件
            this.mapContle.addControl(new T.Control.Scale());
            //添加控件
            this.mapContle.addControl(new T.Control.MapType());
            // 禁止双击放大
            this.mapContle.disableDoubleClickZoom()
            // 禁止滚轮
            this.mapContle.disableScrollWheelZoom()
            // 设置marker 初始化地图为全部marker
            this.setMapMarker(this.$store.state.maxMarkerType * 1, this.$store.state.deviceNowData);
            this.changeMapThemeColor(this.$store.state.maxMapStyle * 1);


        },
        init(sel, transform) {
            var upd = sel.selectAll('path.geojson').data(this.countries);
            upd.enter()
                .append('path')
                .attr("class", "geojson")
                .attr('stroke', 'blue')
                .attr('fill', 'hotpink')
                .attr('fill-opacity', '0.1')
        },

        redraw(sel, transform) {
            sel.selectAll('path.geojson').each(
                function (d, i) {
                    d3.select(this).attr('d', transform.pathFromGeojson)
                }
            )

        },


        init1(sel, transform) {
            var upd = sel.selectAll('path.geojson1').data(this.countries);
            upd.enter()
                .append('path')
                .attr("class", "geojson1")
                .attr('stroke', 'skyblue')
                .attr('fill', 'skyblue')
                .attr('fill-opacity', '0.4')


        },

        redraw1(sel, transform) {
            sel.selectAll('path.geojson1').each(
                function (d, i) {
                    d3.select(this).attr('d', transform.pathFromGeojson)
                }
            )

        },
        // 重置地图层级
        resetMap() {
            this.mapContle.panTo(new T.LngLat(this.$store.state.maxMapSetting.Lng * 1, this.$store.state.maxMapSetting.Lat * 1),
                this.$store.state.maxMapSetting.zIndex * 1)
            // 设置marker 初始化地图为全部marker
            this.setMapMarker(this.$store.state.maxMarkerType * 1, this.$store.state.deviceNowData);
        },

        // 设置地图marker
        setMapMarker(type, data) {
            console.log('设置');
            // type == 1 在线状态  type==-1报警状态
            let map = this.mapContle;
            map.clearOverLays();
            if (this.clusterMarkers) {
                this.clusterMarkers.clearMarkers()
            }
            let that = this;
            //创建图片对象

            var orangeIcon = new T.Icon({
                iconUrl: require('@/assets/mark2.png'),
                iconSize: new T.Point(25, 27),
                iconAnchor: new T.Point(12, 25)
            });
            var redIcon = new T.Icon({
                iconUrl: require('@/assets/mark3.png'),
                iconSize: new T.Point(25, 27),
                iconAnchor: new T.Point(12, 25)
            });
            var greenIcon = new T.Icon({
                iconUrl: require('@/assets/mark1.png'),
                iconSize: new T.Point(25, 27),
                iconAnchor: new T.Point(12, 25)
            });

            var jinggaiGreenIcon = new T.Icon({
                iconUrl: require('@/assets/icon/jinggaig.png'),
                iconSize: new T.Point(25, 27),
                iconAnchor: new T.Point(12, 25)
            });
            var jinggaiOrangeIcon = new T.Icon({
                iconUrl: require('@/assets/icon/jinggaio.png'),
                iconSize: new T.Point(25, 27),
                iconAnchor: new T.Point(12, 25)
            });
            var jinggaiRedIcon = new T.Icon({
                iconUrl: require('@/assets/icon/jinggair.png'),
                iconSize: new T.Point(25, 27),
                iconAnchor: new T.Point(12, 25)
            });

            var shuiweiGreenIcon = new T.Icon({
                iconUrl: require('@/assets/icon/shuiweig.png'),
                iconSize: new T.Point(25, 27),
                iconAnchor: new T.Point(12, 25)
            });
            var shuiweiOrangeIcon = new T.Icon({
                iconUrl: require('@/assets/icon/shuiweio.png'),
                iconSize: new T.Point(25, 27),
                iconAnchor: new T.Point(12, 25)
            });
            var shuiweiRedIcon = new T.Icon({
                iconUrl: require('@/assets/icon/shuiweir.png'),
                iconSize: new T.Point(25, 27),
                iconAnchor: new T.Point(12, 25)
            });

            var yuliangGreenIcon = new T.Icon({
                iconUrl: require('@/assets/icon/yuliangg.png'),
                iconSize: new T.Point(25, 27),
                iconAnchor: new T.Point(12, 25)
            });
            var yuliangOrangeIcon = new T.Icon({
                iconUrl: require('@/assets/icon/yuliango.png'),
                iconSize: new T.Point(25, 27),
                iconAnchor: new T.Point(12, 25)
            });
            var yuliangRedIcon = new T.Icon({
                iconUrl: require('@/assets/icon/yuliangr.png'),
                iconSize: new T.Point(25, 27),
                iconAnchor: new T.Point(12, 25)
            });

            var arrayObj = []

            // 判断当前是根据什么状态进行marker图标显示
            if (type === 1) {
                // 在线状态
                data.forEach((item, index) => {
                    let gcj02towgs84 = GCJ02_WGS84.gcj02towgs84(item.latitude * 1, item.longitude * 1);
                    var latlng = new T.LngLat(gcj02towgs84[0], gcj02towgs84[1]);
                    var marker = '';
                    switch (item.deviceType) {
                        case '智能井盖':
                            if (item.maintain === '1') {
                                // 维护状态
                                marker = new T.Marker(latlng, { icon: jinggaiOrangeIcon });
                            } else if (new Date().getTime() - item.updateTime * 1 > 7776000000) {
                                // 故障状态
                                marker = new T.Marker(latlng, { icon: jinggaiRedIcon });
                            } else {
                                marker = new T.Marker(latlng, { icon: jinggaiGreenIcon });
                            }
                            break;
                        case '水位流速监测':
                            if (item.maintain === '1') {
                                // 维护状态
                                marker = new T.Marker(latlng, { icon: shuiweiOrangeIcon });
                            } else if (new Date().getTime() - item.updateTime * 1 > 7776000000) {
                                // 故障状态
                                marker = new T.Marker(latlng, { icon: shuiweiRedIcon });
                            } else {
                                marker = new T.Marker(latlng, { icon: shuiweiGreenIcon });
                            }
                            break;
                        case '雨量监测':
                            if (item.maintain === '1') {
                                // 维护状态
                                marker = new T.Marker(latlng, { icon: yuliangOrangeIcon });
                            } else if (new Date().getTime() - item.updateTime * 1 > 7776000000) {
                                // 故障状态
                                marker = new T.Marker(latlng, { icon: yuliangRedIcon });
                            } else {
                                marker = new T.Marker(latlng, { icon: yuliangGreenIcon });
                            }
                            break;

                        default:
                            if (item.maintain === '1') {
                                // 维护状态
                                marker = new T.Marker(latlng, { icon: orangeIcon });
                            } else if (new Date().getTime() - item.updateTime * 1 > 7776000000) {
                                // 故障状态
                                marker = new T.Marker(latlng, { icon: redIcon });
                            } else {
                                marker = new T.Marker(latlng, { icon: greenIcon });
                            }
                            break;
                    }

                    marker.addEventListener('click', function (e) {
                        that.checkDeviceData = item;
                        that.deviceDeatilShow = true;
                    }); // 将标注添加到地图中
                    // map.addOverLay(marker);

                    arrayObj.push(marker);
                });
            } else if (type === -1) {
                // 报警状态
                data.forEach((item, index) => {
                    let gcj02towgs84 = GCJ02_WGS84.gcj02towgs84(item.latitude * 1, item.longitude * 1);
                    var latlng = new T.LngLat(gcj02towgs84[0], gcj02towgs84[1]);
                    var marker = '';
                    switch (item.deviceType) {
                        case '智能井盖':
                            if (item.alarmStatus === 1) {
                                marker = new T.Marker(latlng, { icon: jinggaiRedIcon });
                            } else {
                                marker = new T.Marker(latlng, { icon: jinggaiGreenIcon });
                            }
                            break;
                        case '水位流速监测':
                            if (item.alarmStatus === 1) {
                                marker = new T.Marker(latlng, { icon: shuiweiRedIcon });
                            } else {
                                marker = new T.Marker(latlng, { icon: shuiweiGreenIcon });
                            }
                            break;
                        case '雨量监测':
                            if (item.alarmStatus === 1) {
                                marker = new T.Marker(latlng, { icon: yuliangRedIcon });
                            } else {
                                marker = new T.Marker(latlng, { icon: yuliangGreenIcon });
                            }
                            break;

                        default:
                            if (item.alarmStatus === 1) {
                                marker = new T.Marker(latlng, { icon: redIcon });
                            } else {
                                marker = new T.Marker(latlng, { icon: greenIcon });
                            }
                            break;
                    }

                    marker.addEventListener('click', function () {
                        that.checkDeviceData = item;
                        that.deviceDeatilShow = true;
                    }); // 将标注添加到地图中
                    // map.addOverLay(marker);

                    arrayObj.push(marker);
                });
            }



            this.clusterMarkers = new T.MarkerClusterer(map, { markers: arrayObj });
            this.clusterMarkers.setMaxZoom(18)

            // -----------------------
        },

        // 点击了筛选设备
        filterDevice() {
            let deviceData = this.$store.state.deviceNowData
            deviceData = deviceData.filter(item => {
                if (item.deviceType == this.filterDeviceForm.deviceType) {
                    return item
                } else if (
                    this.filterDeviceForm.deviceType == '全部'
                ) {
                    return item
                }
            })


            // 在线状态  智能井盖设备原因 暂不过滤
            deviceData = deviceData.filter(item => {
                if (this.filterDeviceForm.onlineStatus == '全部') {
                    return item
                } else if (this.filterDeviceForm.onlineStatus == '正常') {
                    return item
                }
            })

            // 报警状态
            deviceData = deviceData.filter(item => {
                if (this.filterDeviceForm.alarmStatus == '全部') {
                    return item
                } else if (this.filterDeviceForm.alarmStatus == '报警' && item.alarmStatus) {
                    return item
                } else if (this.filterDeviceForm.alarmStatus == '正常' && !item.alarmStatus) {
                    return item
                }
            })

            this.filterDeviceData = deviceData
            this.filterStatus = true
            this.$message.success(`共筛选出 ${deviceData.length} 个设备`)

            if (deviceData.length) {
                // 打开详情
                this.filterDetailShow = true
                // 设置状态
                this.filterStatus == true
            }

            this.setMapMarker(this.$store.state.maxMarkerType * 1, deviceData);
        },
        // 重置设备
        resetDevice() {
            this.setMapMarker(this.$store.state.maxMarkerType * 1, this.$store.state.deviceNowData);
            // 设备类型
            this.filterDeviceForm = {
                deviceType: '全部',
                alarmStatus: '全部',
                onlineStatus: '全部',
            }
            this.filterDeviceData = [],

                this.filterDetailShow = false
            this.filterStatus == false
        },
        // 打开筛选详情
        openFilterDetail() {
            if (!this.filterStatus || this.filterDeviceData.length == 0) {
                this.$message.warning('未筛选或筛选结果为空')
                return
            } else {
                // 打开详情
                this.filterDetailShow = true
                // 设置状态
                this.filterStatus == true
            }
        },
        // 关闭筛选详情
        closeFilterDetail() {
            this.filterDetailShow = false
            this.filterStatus == false
        },
        // 地图平移至位置
        goDeviceMap(e) {
            let gcj02towgs84 = GCJ02_WGS84.gcj02towgs84(e.latitude * 1, e.longitude * 1);
            var latlng = new T.LngLat(gcj02towgs84[0], gcj02towgs84[1]);
            this.mapContle.panTo(latlng, 18)
            console.log(e);
            // 打开详情
            this.filterDetailShow = false
            // 设置状态
            this.filterStatus == false
        },
        // 打开设备详情
        openDeviceDetail(e) {
            this.checkDeviceData = e;
            this.deviceDeatilShow = true;
        }
    },
    watch: {
        getNewDeviceData() {
            this.setMapMarker(this.$store.state.maxMarkerType * 1, this.$store.state.deviceNowData);
        }
    }
};
</script>

<style lang="less" scoped>
.mapBox {
    height: 100%;
    width: 100%;

    position: relative;

    .leftMenu {
        position: absolute;
        width: 30px;

        left: 10px;
        top: 70px;
        background-color: #fff;
        color: #000;
        z-index: 999;
        cursor: pointer;
        box-sizing: border-box;

        .iconfont {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 30px;
            border-bottom: 1px solid #ccc;
        }

        .iconfont:hover {
            background-color: #eee;
        }
    }

    .menuBox {
        position: absolute;
        right: 10px;
        bottom: 10px;
        background-color: #27a2d3;
        color: #000;
        z-index: 999;
        font-size: 0.3rem;
        font-weight: bold;
        display: flex;

        .list {
            padding: 0.2rem;
            transition: all .3s;
        }

        .check {
            background-color: #155974;
            color: #fff;
        }

        .list:hover {
            background-color: #ddd;
            color: #000;
        }

        .line:hover {
            background-color: #fff;
            cursor: default;
        }
    }

    .topmenuBox {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        top: 10px;
        width: 620px;
        left: 50%;
        margin-left: -310px;
        background-color: #27a2d3;
        color: #000;
        z-index: 999;
        font-size: 0.3rem;
        font-weight: bold;
        display: flex;
        cursor: default;


        .list {
            padding: 0.2rem;
            transition: all .3s;
        }

        .check {
            background-color: #ddd;
        }

        .list:hover {
            background-color: #ddd;
            cursor: pointer;
        }

        .line:hover {
            cursor: default;
            background-color: #27a2d3;
        }

        .deviceSummary {
            position: absolute;
            top: 55px;
            background-color: #27a2d3;
            box-sizing: border-box;
            padding: 10px;
            left: 0;
            width: 620px;
            height: 200px;
            overflow-y: scroll;
            animation: ss .5s;

            .list {
                border-bottom: 1px solid #85b6be;
                padding: 3px 0;
                display: flex;
                justify-content: right;
                cursor: default;
                height: 30px;
                box-sizing: border-box;
                align-items: center;

                .id {
                    width: 100px;
                    flex: 1;
                }

                .name {
                    flex: 1;
                    margin-left: 10px;
                }

                .r {
                    margin-left: 5px;
                    margin-right: 5px;
                }

                .iconfont {
                    cursor: pointer;
                    padding: 5px;
                    width: 20px;
                    height: 20px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    box-sizing: border-box;
                    transition: all .3s;
                    color: #000;
                }

                .iconfont:hover {
                    border-radius: 2px;
                    color: #27a2d3;
                    background-color: #fff;
                }
            }
        }


        @keyframes ss {
            0% {
                top: 40px;
                opacity: 0;
            }

            100% {
                top: 55px;
                opacity: 1;
            }
        }
    }

    .tmap {
        height: 100%;
        width: 100%;
    }
}

.settingBox {
    .list {
        font-size: 0.5rem;
        padding: 20px 0;
        border-bottom: 1px solid #14283e;

        .title {}

        .valueBox {
            margin: 20px 0;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .confimBox {
            display: flex;
            align-items: center;
            justify-content: center;

            .btn {
                font-size: 0.2rem;
                margin: 0 10px;
                box-sizing: border-box;
                padding: 0.15rem;
                border: 1px solid #fff;
                cursor: pointer;
                transition: all 0.5s;
            }

            .btn:hover {
                border: 1px solid #88e3e1;
                background-color: #88e3e1;
                color: #000;
            }
        }
    }
}

.deviceDeatilZindex {
    position: relative;
    z-index: 99999;
}
</style>